import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme, MaTextareaClasses } from '@dxp-module/themes'

const textareaStyles = makeStyles<MyAccountTheme, object, MaTextareaClasses>(
  ({ palette }) => ({
    root: {
      minHeight: 51,
      margin: '0 15px 0 0',
      borderRadius: 0,
      '& fieldset': {
        top: 0,
        borderColor: palette.grey[400],
        borderRadius: 0,
      },
      '& legend': {
        display: 'none',
      },
      '& .Mui-focused': {
        '& fieldset': {
          borderColor: palette.primary.main,
        },
      },
      '& .Mui-error': {
        '& fieldset': {
          borderColor: palette.error.main,
        },
      },
    },
    inputRoot: {
      minHeight: 51,
      height: 'unset',
    },
    formControl: {},
    input: {
      minHeight: 51,
      resize: 'vertical',
      position: 'static',
      MozAppearance: 'textfield',
      WebkitAppearance: 'textfield',
      '&::-webkit-resizer': {
        display: 'none',
      },
      WebkitResizer: 'none',
    },
    helper: {
      color: palette.error.main,
    },
    error: {},
  }),
  { name: 'MyAccount_Textarea' }
)

export default textareaStyles
